import { Injectable } from '@angular/core';
import { HttpService } from '../../services/http/http-service.service';
import { NzModalService, NzMessageService } from 'ng-zorro-antd';
import { cloneDeep } from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class STableService {

  constructor(
    private httpService: HttpService,
    private message: NzMessageService
    ) { }
  refreshTabl(tableObj, clear?) {
    const copyObj = cloneDeep(tableObj);
    if (clear) {
      copyObj.tableData = [];
      copyObj.params = {};
    } else {
      copyObj.tableData = tableObj.tableData;
    }
    copyObj.defaultLoad = !clear;
    copyObj.reLoad = true;
    tableObj = copyObj;
    return tableObj;
  }

  /**
   * 重置按钮输入结果
   */
  resetSearchBar(searchBar, tableObj) {
    const valueArr = Object.values(searchBar);
    const keyArr = Object.keys(searchBar);
    valueArr.forEach((item) => {
      const uiType = item['ui'].type;
      if (uiType === 'date' || uiType === 'input') {
        item['value'] = null;
      } else if (uiType === 'select') {
        item['selectedValue'] = null;
      }
    });
    keyArr.forEach((key) => {
      tableObj.tableParams[key] = '';
    });
  }

  /** 提交可编辑单元格表格数据，非工具 */
  subEditTableData(dataArr) {
    const mapperResult = [];
    if (dataArr && dataArr.length) {
      dataArr.forEach((d) => {
        const temp = {};
        for (const key in d) {
          if (d.hasOwnProperty(key)) {
            if (d[key].others && d[key].others.type === 'select') {
              d[key].value = d[key].others.selectedValue.label + ',' + d[key].others.selectedValue.value;
            }
            if (key !== 'operation') {
              if (d[key].value === null) {
                this.message.error('请将数据填写完整后再提交');
                return;
              }
              temp[key] = d[key].value;
            }
          }
        }
        mapperResult.push(temp);
      });
    }
    return mapperResult;
  }
}
